import { render, staticRenderFns } from "./fail-info.vue?vue&type=template&id=0a9c4a38&scoped=true&"
import script from "./fail-info.vue?vue&type=script&lang=js&"
export * from "./fail-info.vue?vue&type=script&lang=js&"
import style0 from "./fail-info.vue?vue&type=style&index=0&id=0a9c4a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c4a38",
  null
  
)

export default component.exports